import React from 'react';
import FilterState from './FilterState';
import FilterStateOpen from './FilterStateOpen';
import FilterDistrict from './FilterDistrict';
import FilterDistrictOpen from './FilterDistrictOpen';


const NavFilterByDistrict = React.forwardRef((props, ref) => {
    const { filterDistrict, toggleCongressDropdowns, congress, chooseDropdownItem, isMobile } = props;
    const activeBool = congress.state;

    return (
      <div className="filter-panel-dropdown" ref={ref}>
          <span id="filter-title">Filter by Congressional District:</span>
          <div id="state-filter" className="filter-item">
            {filterDistrict.state === true
                ? <FilterStateOpen
                    chooseDropdownItem={chooseDropdownItem}
                    congress={congress}
                    toggleCongressDropdowns={toggleCongressDropdowns}
                    active
                    isMobile={isMobile}
                />
                : <FilterState
                    congress={congress}
                    toggleCongressDropdowns={toggleCongressDropdowns}
                    active
                    isMobile={isMobile}
                />
            }
          </div>
          {isMobile && (
            <p className="conjunction">and</p>
          )}
          <div id="district-filter" className="filter-item">
            {filterDistrict.congressDistrict === true
                ? <FilterDistrictOpen
                    chooseDropdownItem={chooseDropdownItem}
                    congress={congress}
                    toggleCongressDropdowns={toggleCongressDropdowns}
                    isMobile={isMobile}
                    districtInfo={congress.districts[congress.selected.district]}
                  />
                : <FilterDistrict
                    congress={congress}
                    toggleCongressDropdowns={toggleCongressDropdowns}
                    active={activeBool}
                    isMobile={isMobile}
                    districtInfo={congress.districts[congress.selected.district]}
                  />
            }
          </div>
      </div>
    );


});

export default NavFilterByDistrict;
